import { Avatar, Col, Input, Radio, Row, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import './style.css'
import { Button, Loader, Modal, ProfileImage, Text, TextField } from '../../components'
import { useNavigate, useParams } from 'react-router'
import { ApiCaller, Constants, Utils } from '../../config'
import { useDispatch, useSelector } from 'react-redux'
import { JobActions } from '../../store/actions'
import carImg from '../../assets/images/car.svg'
import carDetailTick from '../../assets/images/carDetailTick.svg'
import carDetailCalen from '../../assets/images/calen.png'
import carDetailLocation from '../../assets/images/carDetailLocation.svg'
import callIcon from '../../assets/images/call.png'
import { FaBell } from "react-icons/fa6";
import { Colors, Fonts, Images } from "../../config";
import { MdCall, MdLocationOn } from "react-icons/md";
import { IoMdAlert } from 'react-icons/io'
import './AssignServiceProvider/style.css';


const JobDetail = () => {

    const { id } = useParams();
    const dispatch = useDispatch()

    const navigate = useNavigate();

    // const [showModal, setShowModal] = useState(false);
    // const [selectedServiceProvider, setSelectedServiceProvider] = useState('');
    // const [filteredServiceProviders, setFilteredServiceProviders] = useState([]);
    const { isLoading, jobsDetail, serviceProviders, serviceProvidersLoading, assignServiceProviderLoading } = useSelector(state => state?.JobsManagementReducer);
    const myJobDetails = jobsDetail?.job
    const myJobDetailsAssignments = jobsDetail?.assignments
    // const { jobsDetail  = useSelector(state => state?.JobsManagementReducer);
    // console.log('jobsDetail ', jobsDetail)
    // console.log('filteredServiceProviders ',filteredServiceProviders)
    useEffect(() => {
        dispatch(JobActions.jobsDetail(id))
    }, [id])

    console.log("myJobDetailsAssignments", myJobDetailsAssignments)

    // useEffect(() => {
    //     setFilteredServiceProviders(serviceProviders || []);
    // }, [serviceProviders]);

    // const assignSpHandler = () => {
    //     setShowModal(true);
    //     // as for now setting radius as high as possible And setting limit as max because we dont have radius picker in panel yet and also no infinite scroll implementation for Sp listing.
    //     // also lat, lng is setting from the job response.
    //     const payload = {
    //         latitude: myJobDetails?.latitude,
    //         longitude: myJobDetails?.longitude,
    //         radius: 100,
    //         limit: 10000
    //     }
    //     dispatch(JobActions.getServiceProviders(payload));
    // }
    const onSearch = (searchValue) => {
        // if (!searchValue) {
        //     setFilteredServiceProviders(serviceProviders);
        // } else {
        //     console.log('searchValue', searchValue);

        //     const filtered = filteredServiceProviders.filter((sp) =>
        //         sp?.fullName?.toLowerCase().includes(searchValue.toLowerCase())
        //     );
        //     console.log('filtered', filtered);
        //     // setFilteredServiceProviders([]);
        //     setFilteredServiceProviders(filtered);
        // }
    };

    const onChange = (value) => {
        // console.log("onChange",value);   
        // setSelectedServiceProvider(value);
    }

    // const submitServiceProviderHandler = () => {
    //     if ( id) {
    //         // console.log('selectedServiceProvider ', selectedServiceProvider);
    //         dispatch(JobActions.assignServiceProvider({ serviceProviderId: selectedServiceProvider, jobId: id },
    //             () => {
    //                 setShowModal(false);
    //                 dispatch(JobActions.jobsDetail(id))
    //                 // navigate(-1);
    //                 // window.location.reload();
    //             }
    //         )
    //         );
    //     }
    // }

    const sendNotificationToSpHandler = async () => {
        try {
            if (!id) {
                Utils.showSnackBar({
                    message: 'No Booking id found',
                    severity: "error",
                })
                return
            }

            let res = await ApiCaller.Post(`/admin/job/send-notification`, {
                bookingId: parseInt(id, 10),
            });

            if (res?.data?.status == 200) {
                Utils.showSnackBar({
                    message: res?.data?.data?.message,
                })
            }
            else {
                Utils.showSnackBar({
                    message: res?.data?.error?.message,
                    severity: "error",
                });
            }
        } catch (error) {
            Utils.showSnackBar({
                message: error?.error?.message,
                severity: "error",
            });
        }
    }

    return (
        // <Row className='w-full'>
        <>
            {
                isLoading ?
                    <Row className='loader-container' align='center' justify='center'>
                        <Col span={24} className='loader'>
                            <Loader.Circular />
                        </Col>
                    </Row>
                    :
                    <>
                        <div className="container">
                            <div className="header">
                                <div className="dealership-info"
                                >
                                    <Button.Basic
                                        text=""
                                        variant="text"
                                        className="back-button"
                                        onClick={() => navigate(-1)}
                                        // containerStyle={{ padding: '0px', width: '2rem', alignSelf:'baseline' }}
                                        containerClassName={'back-button-container'}
                                        startIcon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16.007" viewBox="0 0 24 16.007">
                                            <path id="Icon_ionic-ios-arrow-round-back" data-name="Icon ionic-ios-arrow-round-back" d="M16.577,11.558a1.089,1.089,0,0,1,.008,1.534l-5.06,5.077H30.807a1.084,1.084,0,0,1,0,2.167H11.525l5.068,5.077a1.1,1.1,0,0,1-.008,1.534,1.079,1.079,0,0,1-1.526-.008L8.19,20.019h0a1.217,1.217,0,0,1-.225-.342,1.034,1.034,0,0,1-.083-.417A1.087,1.087,0,0,1,8.19,18.5l6.869-6.919A1.062,1.062,0,0,1,16.577,11.558Z" transform="translate(-7.882 -11.252)" />
                                        </svg>

                                        }
                                    />
                                    <div className="logo"
                                    >
                                        <img
                                            src={carImg}
                                            alt="Car Logo"
                                            width={128}
                                            height={64}
                                        />
                                    </div>
                                    <div>
                                        <h1 className="dealership-name">{myJobDetails?.serviceUser?.fullName}</h1>
                                        <div className="dealership-description">
                                            {myJobDetails?.services?.length > 0 &&
                                                myJobDetails?.services?.map(
                                                    (service, index) => (
                                                        <span>{index < 2 ? service?.name + " | " : index == 2 ? service?.name : null}</span>
                                                    )
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="action-buttons">
                                    <div className='gb-container'>
                                        <div className='gb-icon'>GB</div>
                                        <Button.Basic
                                            text={myJobDetails?.vehicleRegistrationNo}
                                            variant="contained"
                                            className="btn btn-smio"

                                        />
                                    </div>
                                    <Button.Basic
                                        text="Assign SP"
                                        variant="contained"
                                        className="btn btn-primary"
                                        onClick={() => navigate(`/assign-service-provider/${id}`)}
                                    />
                                    <Button.Basic
                                        // text="ttt"
                                        // variant="text"
                                        className="bell-btn"
                                        onClick={sendNotificationToSpHandler}
                                        containerClassName={'container-class'}
                                        startIcon={<FaBell color='#FAB700' />
                                        }
                                    />
                                </div>
                            </div>

                            <div className="location-date">
                                <div className="info-item">
                                    <div className="info-icon icon-yellow">
                                        <img
                                            src={carDetailLocation}
                                            alt="Location Logo"
                                            width={24}
                                            height={24}
                                        />
                                    </div>
                                    <span>{myJobDetails?.address}</span>
                                </div>
                                <div className="info-item">
                                    <div className="info-icon icon-red">
                                        <img
                                            src={carDetailCalen}
                                            alt="Location Logo"
                                            width={24}
                                            height={24}
                                        />
                                    </div>
                                    <span>{Utils.formatTimestamp(myJobDetails?.createdAt)}</span>
                                </div>
                                <div className="info-item">
                                    <div className='info-icon icon-red'>
                                        <img
                                            src={callIcon}
                                            alt="Location Logo"
                                            width={24}
                                            height={24}
                                        />
                                    </div>
                                    <span>{myJobDetails?.serviceUser?.phoneNo}</span>
                                </div>
                            </div>

                            <div className="service-requested">
                                <h2 className="service-title">Service Requested:</h2>
                                {/* <div className="service-tags">
                                    {jobsDetail?.services?.length > 0 &&
                                        jobsDetail?.services?.map(
                                            (service, index) => (
                                                <div key={index} className="service-tag">
                                                    <div className="tag-dot">
                                                        <img
                                                            src={carDetailTick}
                                                            alt="Car Logo"
                                                            width={14}
                                                            height={14}
                                                        />
                                                    </div>
                                                    <span>{service?.name}</span>
                                                </div>
                                            )
                                        )}
                                </div> */}
                                {myJobDetails?.services?.length > 0 &&
                                    (myJobDetails?.services?.length > 5 ? (
                                        <Tooltip
                                            title={
                                                <div>
                                                    {myJobDetails.services.slice(5).map((service, index) => (
                                                        <div key={index}>{service?.name}</div>
                                                    ))}
                                                </div>
                                            }
                                        >
                                            <div className="services-container">
                                                {myJobDetails.services.slice(0, 5).map((service, index) => (
                                                    <div key={index} className="service-tag">
                                                        <div className="tag-dot">
                                                            <img
                                                                src={carDetailTick}
                                                                alt="Car Logo"
                                                                width={14}
                                                                height={14}
                                                            />
                                                        </div>
                                                        <span>{service?.name}</span>
                                                    </div>
                                                ))}
                                                <span className="more-tag">+{myJobDetails.services.length - 5} more</span>
                                            </div>
                                        </Tooltip>
                                    ) : (
                                        <div className="services-container">
                                            {myJobDetails.services.map((service, index) => (
                                                <div key={index} className="service-tag">
                                                    <div className="tag-dot">
                                                        <img
                                                            src={carDetailTick}
                                                            alt="Car Logo"
                                                            width={14}
                                                            height={14}
                                                        />
                                                    </div>
                                                    <span>{service?.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                            </div>

                            <div className="additional-info">
                                <h2 className="service-title">Additional Info/ Note</h2>
                                <p className="info-text">
                                    {myJobDetails?.details}
                                </p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '16px' }}>
                                <IoMdAlert color={Colors.Danger} />
                                <span style={{ color: Colors.Danger }}>Services Provider listing will be showcase near to job vicinity.</span>
                            </div>
                            <div className='su-sp-divider ' />
                            {myJobDetails?.serviceProvider && (
                                <div className='quote-details-container'>
                                    <h2 className="service-title">SP Assigned By User</h2>
                                    {/* <Text className="section-heading">Received Quotes:</Text> */}
                                    {/* <div className='pending-quotes-listing-container'> */}
                                    {
                                        // myJobDetailsAssignments?.map((quote) => {
                                        //     return (

                                        // <div className='sp-card' style={{ marginBottom: 20 }}>
                                        //     <Row wrap={false} align="top">
                                        //         <Col flex="80px">
                                        //             <img
                                        //                 src={myJobDetails?.serviceProvider?.imageThumbUrl || Images.MobrageIcon}
                                        //                 alt={myJobDetails?.serviceProvider?.fullName}
                                        //                 className="sp-avatar"
                                        //             />
                                        //         </Col>
                                        //         <Col flex="auto">
                                        //             <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                        //                 <span className="sp-name">
                                        //                     {myJobDetails?.serviceProvider?.fullName || '-'}
                                        //                 </span>
                                        //             </div>
                                        //             <div>
                                        //                 <span className="sp-distance">
                                        //                     {/* (4.5 Miles Away) */}
                                        //                     {Number(myJobDetails?.serviceProvider?.distance).toFixed(2) + " Miles Away" || "4.5 Miles Away"}
                                        //                 </span>
                                        //             </div>

                                        //             <div className="info-row">
                                        //                 <MdCall />
                                        //                 <span>{myJobDetails?.serviceProvider?.phoneNo || "+1 234 567 890"}</span>
                                        //             </div>

                                        //             <div className="info-row">
                                        //                 <MdLocationOn />
                                        //                 <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                        //                     {myJobDetails?.serviceProvider?.address || "4058 Little York Rd, Houston"}
                                        //                 </span>
                                        //             </div>
                                        //         </Col>
                                        //     </Row>

                                        //     <div className="card-divider" />

                                        //     <Row justify="space-around" gutter={16}>
                                        //         <Col style={{ display: 'flex', alignItems: 'center' }}>
                                        //             <span style={{ color: '#22c55e', fontWeight: 600, fontSize: 16 }}>
                                        //                 Assigned
                                        //             </span>
                                        //         </Col>
                                        //         <Col>
                                        //             <Button.Basic
                                        //                 text={'View Profile'}
                                        //                 className='view-profile-button'
                                        //                 containerClassName='view-profile-button-container'
                                        //                 onClick={() => navigate(`/service-provider/${myJobDetails?.serviceProvider?.id}`)}
                                        //                 buttonStyle={{ width: '100%', backgroundColor: '#40a9ff', color: '#fff', borderRadius: 6, height: 40 }}
                                        //             />
                                        //         </Col>
                                        //     </Row>
                                        // </div>
                                        <div className='my-card'>
                                            <Row wrap={false} align="top">
                                                <Col flex="80px">
                                                    <ProfileImage
                                                        src={myJobDetails?.serviceProvider?.imageThumbUrl}
                                                        fallback={Images.MobrageIcon}
                                                        alt={myJobDetails?.serviceProvider?.fullName || "provider"}
                                                        className="my-avatar"
                                                        height={60}
                                                        width={60}
                                                    />
                                                </Col>

                                                <Col flex="auto">
                                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                                        <span className="sp-name">
                                                            {myJobDetails?.serviceProvider?.fullName || '-'}
                                                        </span>
                                                    </div>

                                                    <div>
                                                        <span className="sp-distance">
                                                            {Number(myJobDetails?.serviceProvider?.distance).toFixed(2) + " Miles Away"}
                                                        </span>
                                                    </div>

                                                    <div className="info-row">
                                                        <MdCall />
                                                        <span>{myJobDetails?.serviceProvider?.phoneNo}</span>
                                                    </div>

                                                    <div className="info-row">
                                                        <img
                                                            src={carDetailLocation}
                                                            alt="Location Logo"
                                                            width={16}
                                                            height={16}
                                                        />
                                                        {/* <span style={{
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '100%'
                                                            }}>
                                                                {myJobDetails?.serviceProvider?.address || "4058 Little York Rd, Houston"}
                                                            </span> */}
                                                        < Tooltip title={myJobDetails?.serviceProvider?.address}>
                                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                                                {myJobDetails?.serviceProvider?.address}
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className="card-divider" />

                                            <Row gutter={16} style={{ justifyContent: 'space-between', display: 'flex' }}>
                                                <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ color: '#22c55e', fontWeight: 600, fontSize: 16 }}>
                                                        Assigned
                                                    </span>
                                                </Col>

                                                <Col span={12} style={{ display: 'flex', alignItems: 'center', justifyContent: "right" }}>
                                                    <Button.Basic
                                                        text={'View Profile'}
                                                        className='view-profile-button'
                                                        containerClassName='view-profile-button-container'
                                                        onClick={() => navigate(`/service-provider/${myJobDetails?.serviceProvider?.id}`)}
                                                        buttonStyle={{
                                                            width: '100%',
                                                            backgroundColor: '#40a9ff',
                                                            color: '#fff',
                                                            borderRadius: 6,
                                                            height: 40
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>


                                        //     )
                                        // })
                                    }
                                    {/* </div> */}

                                </div>
                            )}
                            <div className='su-sp-divider ' />
                            {myJobDetailsAssignments?.length > 0 && (
                                <div className='quote-details-container'>
                                    <h2 className="service-title">SP Assigned By Admin</h2>
                                    <Row wrap gutter={[16, 16]}>
                                        {/* <Text className="section-heading">Received Quotes:</Text> */}
                                        {/* <div className=''> */}
                                        {
                                            myJobDetailsAssignments?.map((quote) => {
                                                return (
                                                    <Col xs={24} sm={12} lg={8} key={quote.id} style={{ padding: 10, }}>
                                                        <div className="sp-card">
                                                            <Row wrap={false} align="top">
                                                                <Col flex="80px">
                                                                    <ProfileImage
                                                                        src={quote?.serviceProvider?.imageThumbUrl}
                                                                        fallback={Images.MobrageIcon}
                                                                        alt={quote?.serviceProvider?.fullName || "provider"}
                                                                        height={60}
                                                                        width={60}
                                                                        className="sp-avatar"
                                                                    />
                                                                </Col>
                                                                <Col flex="auto">
                                                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                                                        <span className="sp-name">
                                                                            {quote?.serviceProvider?.fullName || '-'}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="sp-distance">
                                                                            {/* (4.5 Miles Away) */}
                                                                            {Number(quote?.serviceProvider?.distance).toFixed(2) + " Miles Away" || "4.5 Miles Away"}
                                                                        </span>
                                                                    </div>

                                                                    <div className="info-row">
                                                                        <MdCall />
                                                                        <span>{quote?.serviceProvider?.phoneNo || quote?.serviceProvider?.phoneNo || "+1 234 567 890"}</span>
                                                                    </div>

                                                                    <div className="info-row">
                                                                        <img
                                                                            src={carDetailLocation}
                                                                            alt="Location Logo"
                                                                            width={16}
                                                                            height={16}
                                                                        />
                                                                        {/* <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                                                        {quote?.serviceProvider?.address || "4058 Little York Rd, Houston"}
                                                                    </span> */}
                                                                        < Tooltip title={quote?.serviceProvider?.userDetail?.businessLocation}>
                                                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                                                                                {quote?.serviceProvider?.userDetail?.businessLocation}
                                                                            </span>
                                                                        </Tooltip>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <div className="card-divider" />

                                                            <Row justify="space-between" gutter={16}>
                                                                <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <span style={{ color: '#22c55e', fontWeight: 600, fontSize: 16 }}>
                                                                        Assigned
                                                                    </span>
                                                                </Col>
                                                                <Col span={12} style={{ display: 'flex', alignItems: 'center', justifyContent: "right" }}>
                                                                    <Button.Basic
                                                                        text={'View Profile'}
                                                                        className='view-profile-button'
                                                                        containerClassName='view-profile-button-container'
                                                                        onClick={() => navigate(`/service-provider/${quote?.serviceProvider?.id}`)}
                                                                        buttonStyle={{ width: '100%', backgroundColor: '#40a9ff', color: '#fff', borderRadius: 6, height: 40 }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                )
                                            })
                                        }
                                        {/* </div> */}
                                    </Row>
                                </div>
                            )}

                        </div>

                        {/* <Modal.AntDesignModal
                            title=""
                            isModalVisible={showModal}
                            handleCancel={() => {
                                setShowModal(false);
                                // setSelectedServiceProvider('');
                            }}
                        >
                            <Row justify="center">
                                <Col>
                                    <Text.Heading
                                        fontSize={20}
                                        fontFamily={Fonts["Poppins-SemiBold"]}
                                        color={Colors.Black}
                                        fontWeight={600}
                                        display="inline-block"
                                        text={"Assign this Job to a Service Provider"}

                                    />
                                </Col>
                            </Row>

                            {
                                serviceProvidersLoading ?
                                    <Row className='loader-container' align='center' justify='center'>
                                        <Col span={24} className='loader'>
                                            <Loader.Circular />
                                        </Col>
                                    </Row>
                                    :
                                    <Row justify="center">
                                        <TextField.SelectField
                                            // key={filteredServiceProviders.length} // This forces a re-render
                                            showSearch={true}
                                            placeholder="Search Service Provider"
                                            className="service-provider-search-textfield"
                                            containerClassName="service-provider-search-textfield-container"
                                            value={selectedServiceProvider}
                                            onChange={onChange}
                                            onSearch={onSearch}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            // filterOption={(input, option) =>
                                            //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            //   }
                                            data={
                                                serviceProviders?.map((sp) => ({
                                                    label: sp?.fullName,
                                                    value: sp?.id
                                                }))}
                                        // filterOption={(input, option) =>
                                        //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        //   }
                                        //   options={[
                                        //     {
                                        //       value: '1',
                                        //       label: 'Jack',
                                        //     },
                                        //     {
                                        //       value: '2',
                                        //       label: 'Lucy',
                                        //     },
                                        //     {
                                        //       value: '3',
                                        //       label: 'Tom',
                                        //     },
                                        //   ]}

                                        />
                                    </Row>
                            }

                            <Row justify="center">
                                <Col span={24}>

                                    {assignServiceProviderLoading ?
                                        <Row className='loader-container' align='center' justify='center'>
                                            <Col span={24} className='loader'>
                                                <Loader.Circular />
                                            </Col>
                                        </Row>
                                        :
                                        <Button.Basic
                                            onClick={submitServiceProviderHandler}
                                            text={"Assign Job"}
                                            className="service-provider-email-btn"
                                        />}
                                </Col>
                            </Row>
                        </Modal.AntDesignModal> */}
                    </>
            }
        </>
        // </Row>
    )
}

export default JobDetail